import loadCommands from './commands';
import loadPanels from './panels';

export default (editor, opts = {}) => {
    
    loadCommands(editor,opts);
    // loadPanels(editor,opts);

};